import ROICalculator from "@/components/ROICalculator";
import LandingNav from "@/components/landing/LandingNav";
import Hero from "@/components/landing/Hero";
import PillarChecklists from "@/components/landing/PillarChecklists";
import PillarPonto from "@/components/landing/PillarPonto";
import PillarEstoque from "@/components/landing/PillarEstoque";
import Ecosystem from "@/components/landing/Ecosystem";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import { FinalCta, LandingFooter } from "@/components/landing/FinalCta";

export default function Landing() {
  return (
    <div className="min-h-screen bg-stone-50 overflow-x-hidden">
      <LandingNav />
      <Hero />
      <PillarChecklists />
      <PillarPonto />
      <PillarEstoque />
      <Ecosystem />
      <Testimonials />
      <div data-testid="landing-roi-section" className="scroll-mt-16">
        <ROICalculator />
      </div>
      <FAQ />
      <FinalCta />
      <LandingFooter />
    </div>
  );
}
